<template>
    <a :href="'/Payment/'+row.PaymentCode" target="_blank">{{row.PaymentCode}}</a>
</template>

<script>
export default {
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{

    }
}
</script>